export default __webpack_public_path__ + "static/media/icon_close_sm.d5bc42f1.svg";